import "./NFTabContainer.css";
interface IProps {
  index: number;
  currentIndex: number;
  children: React.ReactNode;
}

export const NFTabContainer = ({ index, currentIndex, children }: IProps) => {
  if (index !== currentIndex) {
    return <></>;
  }

  return (
    <div
      className={"panel-body tabs-menu-body main-content-body-right nf-tab-container"}
    >
      {children}
    </div>
  );
};
